import { UseQueryResult, useQuery } from 'react-query';
import { SalesPortalPackageRetrieve } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalPackageProps {
  gym?: string;
  packageId?: string;
  profileId?: string;
}

export default function useSalesPortalPackage({
  gym,
  packageId,
  profileId,
}: IUseSalesPortalPackageProps): UseQueryResult<{ data: SalesPortalPackageRetrieve }> {
  return useQuery(
    ['salesPortalPackages', gym, packageId, profileId],
    () => client.get(`sales-portal/gyms/${gym}/packages/${packageId}/`),
    {
      enabled: !!gym && !!packageId,
    },
  );
}
